"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.haulingStatisticReducer = exports.haulingStatisticAction = exports.haulingStatisticTypes = void 0;
const hauling_statistic_component_1 = __importDefault(require("./sub-components/hauling-statistic.component"));
const hauling_statistic_action_1 = __importDefault(require("./hauling-statistic.action"));
exports.haulingStatisticAction = hauling_statistic_action_1.default;
const hauling_statistic_reducer_1 = __importDefault(require("./hauling-statistic.reducer"));
exports.haulingStatisticReducer = hauling_statistic_reducer_1.default;
const hauling_statistic_types_1 = require("./hauling-statistic.types");
Object.defineProperty(exports, "haulingStatisticTypes", { enumerable: true, get: function () { return hauling_statistic_types_1.haulingStatisticTypes; } });
exports.default = hauling_statistic_component_1.default;
